<template>
  <card shadow class="card shadow bg-gradient-secondary" no-body>
    <LessonInfoEdit />
  </card>
</template>
<script>
import LessonInfoEdit from "./../components/lesson/LessonInfoEdit.vue";
export default {
  name: "LessonEdit",
  components: { LessonInfoEdit },
};
</script>
<style></style>
